import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewDocument = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "#C6CCDA",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3214_513)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M4 7.2318C4.01234 7.21123 4.0288 7.19271 4.03703 7.17111C4.16869 6.84401 4.41659 6.67121 4.77248 6.67121C6.00167 6.67018 7.23086 6.67018 8.46004 6.67018C10.0225 6.67018 11.585 6.66915 13.1474 6.67121C13.6946 6.67224 14.0557 7.16391 13.8736 7.66176C13.7728 7.93845 13.5712 8.10303 13.2739 8.13903C13.1814 8.15035 13.0867 8.15343 12.9931 8.15343C10.5605 8.15446 8.12883 8.15446 5.69617 8.15446C5.63034 8.15446 5.56451 8.15446 5.48942 8.15446C5.48942 11.5016 5.48942 14.827 5.48942 18.1618C8.82211 18.1618 12.1486 18.1618 15.4988 18.1618C15.4988 18.099 15.4988 18.0342 15.4988 17.9684C15.4988 15.6355 15.4988 13.3016 15.4988 10.9687C15.4988 10.5614 15.7004 10.2827 16.0584 10.188C16.4863 10.0738 16.9306 10.3865 16.9677 10.8288C16.9728 10.8906 16.9759 10.9533 16.9759 11.016C16.9759 13.6092 16.9749 16.2033 16.9779 18.7964C16.9779 19.1431 16.8771 19.4301 16.5459 19.573C16.4091 19.6327 16.2435 19.6471 16.0913 19.6471C12.9304 19.6512 9.76843 19.6502 6.60752 19.6502C6.05516 19.6502 5.5028 19.6348 4.95146 19.6553C4.49373 19.6718 4.16252 19.5237 4 19.0762C4 15.1284 4 11.1796 4 7.2318Z",
				fill: "grey"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M18.453 6.5313C18.4221 6.58479 18.4026 6.64856 18.3604 6.69074C16.0789 8.97528 13.7944 11.2578 11.5129 13.5433C11.2764 13.7799 11.013 13.8961 10.6829 13.7933C10.1963 13.6421 10.0132 13.0373 10.33 12.6382C10.3815 12.5733 10.4411 12.5137 10.4998 12.4551C12.7751 10.1787 15.0514 7.90347 17.3277 5.62716C17.3668 5.58807 17.4038 5.54692 17.4655 5.48109C17.3791 5.48109 17.3246 5.48109 17.2701 5.48109C16.369 5.48109 15.468 5.48315 14.5669 5.48006C14.2418 5.47904 13.9713 5.27434 13.8746 4.9709C13.7769 4.66644 13.8695 4.32699 14.139 4.15625C14.2758 4.06881 14.4568 4.01018 14.6183 4.00915C16.1499 3.99784 17.6805 3.99887 19.2121 4.00504C19.712 4.0071 20 4.31157 20 4.81147C20 6.35335 20.001 7.89421 19.999 9.43609C19.9979 9.80845 19.7192 10.116 19.3551 10.1643C18.993 10.2117 18.6422 9.9792 18.5507 9.61918C18.5239 9.5153 18.5219 9.40318 18.5219 9.29414C18.5198 8.44554 18.5209 7.59591 18.5209 6.74731C18.5209 6.69177 18.5209 6.63622 18.5209 6.58068C18.4972 6.56319 18.4756 6.54673 18.453 6.5313Z",
				fill: "grey"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3214_513",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 15.6564,
				fill: "white",
				transform: "translate(4 4)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgViewDocument);
export default ForwardRef;
